import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "font-weight-bolder text-dark m-0" }
const _hoisted_3 = ["onClick"]

import { ref } from 'vue';
    import { useI18n } from "vue-i18n/index";
    import { useStore } from "vuex";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AddEditModuleDrawer',
  props: {
    action: null,
    item: null
  },
  emits: ["reload"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'reload', data: any): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        action: 'add' | 'edit',
        item: any
    };

    const { t } = useI18n();
    const store = useStore();
    const drawerVisible = ref(false);
    const titleDrawer  = ref('');
    const loader = ref(false);

    

    

    const openDrawer = () => {
        drawerVisible.value = true;
    };

    const onOpen = () => {
        titleDrawer.value = t('addModule');
    }

    const onClosed = () => {
        titleDrawer.value = ''
    }

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: drawerVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drawerVisible).value = $event)),
    "show-close": false,
    direction: "ltr",
    "close-on-click-modal": false,
    class: "drawer-custom w-100 w-md-500px",
    onOpen: onOpen,
    onClosed: onClosed
  }, {
    header: _withCtx(({ close, titleId }) => [
      _createElementVNode("div", {
        id: titleId,
        class: "d-flex align-items-start justify-content-between"
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(titleDrawer.value), 1),
        _createElementVNode("i", {
          class: "bi bi-x-lg fs-1 cursor-pointer text-black text-hover-danger",
          onClick: close
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})